<template>
  <div class="jumbotron">
      <h2>Skills</h2>
    <div class="container">
    </div>
  </div>

  <div class="skills">
    <ul class="center">
        <li><img src="../assets/java.png" id="iconSize"></li>
        <li><img src="../assets/mysql.png" id="iconSize"></li>
        <li><img src="../assets/oracle.png" id="iconSize"></li><br>
        <li>SpringとDBで簡単なWebアプリが作成可能</li>
      </ul>
      <ul class="center">
        <li><img src="../assets/html.png" id="iconSize"></li>
        <li><img src="../assets/css.png" id="iconSize"></li>
        <li><img src="../assets/javascript.png" id="iconSize"></li><br>
        <li>HP作成・更新作業可能</li><br>
      </ul>
      <ul class="center">
        <li><img src="../assets/jquery.png" id="iconSize"></li>
        <li><img src="../assets/vue.png" id="iconSize"></li><br>
        <li>当HP作成レベル</li>
      </ul>
      <ul class="center">
        <li><img src="../assets/react.png" id="iconSize"></li>
        <li><img src="../assets/androidstudio.png" id="iconSize"></li><br>
        <li>ReactNative使用経験有り</li><br>
        <li>AndroidStudio（Java）でも作成可能</li>
      </ul>
      <p>資格：JavaSilver,OracleBronze12c</p>
    </div>
</template>

<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}

#iconSize {
    width: 55px;
}
.center {
    text-align: center;
}

h2 {
  position: relative;
  padding: 1rem 2rem calc(1rem + 10px);
  background: #fff100;
}

h2:before {
  position: absolute;
  top: -7px;
  left: -7px;
  width: 100%;
  height: 100%;
  content: '';
  border: 4px solid #000;
}
</style>
